import { AbstractControl, ValidatorFn } from '@angular/forms';

export const validateDNI = (value) => {
    const match = value.match(/^(\d{8})([A-Z])$/);

    if (match) {
        const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        const letter = letters.charAt(parseInt(value, 10) % 23);

        return String(letter) === String(value.charAt(8));
    }

    return false;
};

export const dni = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        let v: string = control.value;

        if (!v) {
            return null;
        }

        v = v.toUpperCase().replace(/\s/, '');

        return validateDNI(v) ? null : { dni: true };
    };
};
